import React from "react";
import { Link, useLocation } from "react-router-dom";
import { CheckCircle2, Clock, XCircle } from "lucide-react";

export function CheckoutSuccess() {
  const q = new URLSearchParams(useLocation().search);
  return <Result icon={CheckCircle2} color="#16A34A" title="Pagamento aprovado!" msg="Recebemos sua confirmação. Em breve entraremos em contato pelo WhatsApp para acompanhamento da produção." order={q.get("order")} />;
}
export function CheckoutPending() {
  const q = new URLSearchParams(useLocation().search);
  return <Result icon={Clock} color="#D4AF37" title="Aguardando pagamento" msg="Assim que seu pagamento for confirmado, iniciamos a produção do seu pedido." order={q.get("order")} />;
}
export function CheckoutFailure() {
  const q = new URLSearchParams(useLocation().search);
  return <Result icon={XCircle} color="#E66E6E" title="Pagamento não concluído" msg="Não conseguimos processar o pagamento. Você pode tentar novamente pelo carrinho ou falar com nossa equipe." order={q.get("order")} />;
}

function Result({ icon: Icon, color, title, msg, order }) {
  return (
    <div className="mx-auto max-w-2xl px-6 py-24 text-center" data-testid="checkout-result">
      <div className="w-20 h-20 rounded-full mx-auto flex items-center justify-center" style={{ backgroundColor: color + "22", color }}>
        <Icon size={38} />
      </div>
      <h1 className="mt-6 font-display text-4xl text-[#0D1B2A]">{title}</h1>
      <p className="mt-3 text-[#3A4A5F]">{msg}</p>
      {order && <div className="mt-2 text-xs text-[#6B7280]">Pedido: {order}</div>}
      <div className="mt-8 flex justify-center gap-3">
        <Link to="/catalogo" className="btn-outline-navy">Continuar comprando</Link>
        <a href="https://wa.me/5542984285953" target="_blank" rel="noreferrer" className="btn-gold">Falar no WhatsApp</a>
      </div>
    </div>
  );
}
